import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState, useRef } from "react";
import { InputNumber } from 'primereact/inputnumber';
import api from "../../services/api";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import "../../assets/css/index.css"
import { useReport } from "../../context/report";
import { useReactToPrint } from "react-to-print";

export const Producao = () => {
    const { data } = useReport();
    const [grupos, setGrupos] = useState(data.grupos);

    const toast = useRef(null);
    const componentRef = useRef(null)

    const metaEditor = (options) => {
        return <InputNumber value={options.value} onValueChange={e => options.editorCallback(e.target.value)} />
    }

    function onCellEditComplete(e) {
        let { newRowData, rowIndex } = e;

        let copy = [...grupos];
        if (copy[rowIndex].meta !== newRowData.meta && parseFloat(newRowData.meta)) {
            api.post('metas/update', {
                'importacao_id': data.importacao_id,
                'turma_id': data.turma_id,
                'meta_id': newRowData.meta_id,
                'grupo': newRowData.value,
                'valor': newRowData.meta
            }).then((response) => {
                let grupos2 = [...grupos];
                grupos2[rowIndex] = newRowData;
                setGrupos(grupos2);

                toast.current.show({ summary: 'Concluído', severity: 'success', detail: response.data.message })

            }).catch((error) => {
                toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
            });
        }
    }

    useEffect(() => {
        setGrupos(data.grupos);
    }, [data]);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    return (
        <>
            <Button className="p-m-3" icon="pi pi-print" onClick={handlePrint} />
            <div ref={componentRef} className="p-grid" >
                <Toast ref={toast} />
                <div className="p-col-8 p-d-flex p-flex-column p-mt-">
                    <div className="p-grid" style={{ border: '1px solid black', borderRadius: 8, marginTop: 8, marginLeft: 8 }}>
                        <div className="p-col-4">
                            <h3 style={{ textAlign: 'center' }}>Data: {data.data}</h3>
                        </div>
                        <div className="p-col-4">
                            <h3 style={{ textAlign: 'center' }}>{data.turma}</h3>
                        </div>
                        <div className="p-col-4">
                            <h3 style={{ textAlign: 'center' }}>864h por Turno</h3>
                        </div>
                    </div>
                    <div className="p-grid">
                        <div className="p-col-10">
                            <DataTable header={() => (
                                <span className="header-title">Meta por Grupo</span>
                            )} className="p-m-2 datatable-header" editMode="cell" dataKey="value" value={grupos}>
                                <Column field="label" style={{ padding: 6 }} />
                                <Column field="meta" onCellEditComplete={e => onCellEditComplete(e)} editor={(options) => metaEditor(options)} style={{ width: '15%', padding: 0 }} />
                            </DataTable>
                        </div>
                    </div>
                    <div className="p-grid">
                        <div className="p-col-10">
                            <DataTable header={() => (
                                <span className="header-title">Meta por Turma</span>
                            )} className="p-m-2 datatable-header" editMode="cell" value={data.meta_turma}>
                                <Column field="nome" style={{ padding: 6, fontWeight: 'bold' }} />
                                <Column field="valor" style={{ padding: 0 }} body={(rowData) => {
                                    if (rowData.nome === 'Meta do Dia em Metros por Turma') {
                                        let total = 0;
                                        grupos.forEach(element => {
                                            total += parseFloat(element.meta);
                                        });
                                        return total;
                                    } else if (rowData.nome === 'Défict Metragem') {
                                        let meta = 0;
                                        grupos.forEach(element => {
                                            meta += parseFloat(element.meta);
                                        });

                                        let total = data.meta_turma[1].valor;

                                        return total - meta;
                                    } else {
                                        return rowData.valor;
                                    }
                                }} />
                            </DataTable>
                        </div>
                    </div>
                    <div className="p-grid">
                        <div className="p-col-10">
                            <DataTable header={() => (
                                <span className="header-title">Tempos</span>
                            )} className="p-m-2 datatable-header" value={data.paradas_turma}>
                                <Column field="nome" style={{ padding: 6, fontWeight: 'bold' }} />
                                <Column field="valor" style={{ padding: 0 }} />
                            </DataTable>
                        </div>
                    </div>
                </div>
                <div className="p-col-4">
                    {data ? data.dados.map((element, index) => (
                        <div key={'grupo' + index}>
                            <DataTable header={() => (
                                <span>{element.nome}</span>
                            )} className="p-m-2 datatable-header" key={index} value={element.dados}>
                                <Column field="nome" style={{ padding: 4 }} />
                                <Column field="valor" style={{ padding: 0 }} body={(rowData) => {
                                    if (rowData.nome === 'Meta do Dia') {
                                        return grupos[index].meta;
                                    } else if (rowData.nome === 'Défict') {
                                        return element.dados[1].valor - grupos[index].meta;
                                    } else {
                                        return rowData.valor;
                                    }
                                }} />
                            </DataTable>
                        </div>
                    )) : null}
                </div>
            </div>
        </>
    )
};